import { Button, Segmented, Space, Switch, Table, Typography } from "antd";
import React from "react";

const fixedColumns = [
  {
    title: "ID",
    dataIndex: "id",
    width: 100,
    fixed: "left",
  },

  {
    title: "Group",
    width: 120,
    render: (_: any, record: any) => `Group ${Math.floor(record.id / 4)}`,
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO(eslint-baseline): address @typescript-eslint/no-unused-vars */
    onCell: (record: any, a: any, b: any) => {
      return {
        rowSpan: record.id % 4 === 0 ? 4 : 0,
      };
    },
  },
  {
    title: "Age",
    dataIndex: "age",
    width: 100,
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO(eslint-baseline): address @typescript-eslint/no-unused-vars */
    onCell: (record: any, a: any, b: any) => {
      return {
        rowSpan: record.id % 4 === 0 ? 4 : 0,
      };
    },
    fixed: true,
  },
  {
    title: "Address 1",
    dataIndex: "address1",
    onCell: (record: any) => ({
      colSpan: record.id % 4 === 0 ? 0 : 1,
    }),
  },
  {
    title: "Address 2",
    dataIndex: "address2",
  },
  {
    title: "Address 3",
    dataIndex: "address3",
  },
  {
    title: "Action",
    width: 150,
    fixed: "right",
    render: () => (
      <Space>
        <Typography.Link data-testid="component-test-action-1">
          Action1
        </Typography.Link>
        <Typography.Link data-testid="component-test-action-2">
          Action2
        </Typography.Link>
      </Space>
    ),
  },
];
const columns = [
  {
    title: "ID",
    dataIndex: "id",
    width: 100,
  },
  {
    title: "FistName",
    dataIndex: "firstName",
    width: 120,
  },
  {
    title: "LastName",
    dataIndex: "lastName",
    width: 120,
  },
];
const getData = (count: any) => {
  const data = new Array(count).fill(null).map((_, index) => ({
    id: index,
    firstName: `First_${index.toString(16)}`,
    lastName: `Last_${index.toString(16)}`,
    age: 25 + (index % 10),
    address1: `New York No. ${index} Lake Park`,
    address2: `London No. ${index} Lake Park`,
    address3: `Sydney No. ${index} Lake Park`,
  }));
  return data;
};

const App = () => {
  const [fixed, setFixed] = React.useState(true);
  const [bordered, setBordered] = React.useState(true);
  const [expanded, setExpanded] = React.useState(false);
  const [empty, setEmpty] = React.useState(false);
  const [count, setCount] = React.useState(20);
  const tblRef = React.useRef<any>(null);
  const data = React.useMemo(() => getData(count), [count]);
  const mergedColumns: any = React.useMemo(() => {
    if (!fixed) {
      return columns;
    }
    if (!expanded) {
      return fixedColumns;
    }
    return fixedColumns.map((col) => ({
      ...col,
      onCell: undefined,
    }));
  }, [expanded, fixed]);
  const expandableProps = React.useMemo(() => {
    if (!expanded) {
      return undefined;
    }
    return {
      columnWidth: 48,
      expandedRowRender: (record: any) => (
        <p
          style={{
            margin: 0,
          }}
        >
          🎉 Expanded {record.address1}
        </p>
      ),
      rowExpandable: (record: any) => record.id % 2 === 0,
    };
  }, [expanded]);
  return (
    <div
      style={{
        padding: 64,
      }}
    >
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
      >
        <Space>
          <Switch
            checked={bordered}
            onChange={() => setBordered(!bordered)}
            checkedChildren="Bordered"
            unCheckedChildren="Bordered"
          />
          <Switch
            checked={fixed}
            onChange={() => setFixed(!fixed)}
            checkedChildren="Fixed"
            unCheckedChildren="Fixed"
          />
          <Switch
            checked={expanded}
            onChange={() => setExpanded(!expanded)}
            checkedChildren="Expandable"
            unCheckedChildren="Expandable"
          />
          <Switch
            checked={empty}
            onChange={() => setEmpty(!empty)}
            checkedChildren="Empty"
            unCheckedChildren="Empty"
          />
          <Segmented
            value={count}
            onChange={(value) => setCount(value)}
            options={[
              {
                label: "None",
                value: 0,
              },
              {
                label: "Less",
                value: 4,
              },
              {
                label: "Lot",
                value: 10000,
              },
            ]}
          />

          {data.length >= 999 && (
            <Button
              onClick={() => {
                tblRef.current?.scrollTo({
                  index: 999,
                });
              }}
            >
              Scroll To index 999
            </Button>
          )}
        </Space>

        <Table
          bordered={bordered}
          virtual
          columns={mergedColumns}
          scroll={{
            x: 2000,
            y: 400,
          }}
          rowKey="id"
          dataSource={empty ? [] : data}
          pagination={false}
          ref={tblRef}
          rowSelection={
            expanded
              ? undefined
              : {
                  type: "radio",
                  columnWidth: 48,
                }
          }
          expandable={expandableProps}
        />
      </Space>
    </div>
  );
};
const ComponentDemo = App;

export default ComponentDemo;
